import { useState, useRef, useEffect } from "react";
import WithSidebar from "../../layouts/WithSidebar";
import "./profile.css";
import Input from "../../blocks/Input";
import { useForm } from "../../hooks/useForm";
import ProfileFrom from "../../components/Profile";

const Profile = ({ edit, create, id }) => {
  const [inputFields, handleChange, setInputFields] = useForm({
    officeId: {
      name: "officeId",
      value: "",
      type: "text",
      placeholder: "office ID",
    },
    officeCode: {
      name: "officeCode",
      value: "",
      type: "text",
      placeholder: "R12345",
    },
    email: {
      name: "email",
      value: "",
      type: "text",
      placeholder: "agency@example.com",
    },
    phone: {
      name: "phone",
      value: "",
      type: "text",
      placeholder: "(+237) 696 88 77 55",
    },
    accounting: {
      name: "accounting",
      value: "",
      type: "text",
      placeholder: "100-199",
    },
    iata: {
      name: "iata",
      value: "",
      type: "text",
      placeholder: "THR",
    },
    username: {
      name: "username",
      value: "",
      type: "text",
      placeholder: "Parvaz",
    },
    mobile: {
      name: "mobile",
      value: "",
      type: "text",
      placeholder: "0912 *** ** **",
    },
    city: {
      name: "city",
      value: "",
      type: "select",
      selected: null,
      items: [
        { label: "Tehran", data: { value: 1, name: "tehran" } },
        { label: "Tehran", data: { value: 1, name: "tehran" } },
      ],
      icon: <i className="icon-Star-1"></i>,
    },
    address: {
      name: "address",
      value: "",
      type: "text",
      placeholder: "Street, Avenue, Alley, Plaque",
    },
    currency: {
      name: "currency",
      value: "",
      type: "select",
      items: [
        { label: "Rial", data: { value: 1, name: "Rial" } },
        { label: "Rial", data: { value: 1, name: "Rial" } },
      ],
    },
  });


  useEffect( () => {
    if(id) {
      //request for setInputs
    }
  })

  const handleSelectDropDown = async (data) => {};

  return (
    <WithSidebar pageTitle="Create Office " breadcrumb={"Dashboard > Profile > Create Office"}>

      <ProfileFrom type={'create'}/>

      {/* <div className="form-container__header">Create Office</div>
      <div className="form-container__inputs">
        <div className="row">
          <div className="officeId">
            <label>Office ID</label>
            <Input
              className="extra"
              inputField={inputFields.officeId}
              onChange={handleChange}
            />
          </div>
          <div className="officeCode">
            <label>Office Code</label>
            <Input
              className="extra"
              inputField={inputFields.officeCode}
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="row">
          <div className="officeId">
            <label>Email Address</label>
            <Input
              className="extra"
              inputField={inputFields.email}
              onChange={handleChange}
            />
          </div>
          <div className="officeCode">
            <label>Office Phone Number</label>
            <Input
              className="extra"
              inputField={inputFields.phone}
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="row">
          <div className="officeId">
            <label>Accounting Code</label>
            <Input
              className="extra"
              inputField={inputFields.accounting}
              onChange={handleChange}
            />
          </div>
          <div className="officeCode">
            <label>IATA Code</label>
            <Input
              className="extra"
              inputField={inputFields.iata}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="line"></div>
        <div className="form-container__header">Contact Person</div>
        <div className="row">
          <div className="officeId">
            <label>username</label>
            <Input
              className="extra"
              inputField={inputFields.username}
              onChange={handleChange}
            />
          </div>
          <div className="officeCode">
            <label>Mobile Number</label>
            <Input
              className="extra"
              inputField={inputFields.mobile}
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="line"></div>
        <div className="form-container__header">Address Information</div>
        <div className="row">
          <div className="city">
            <label>City</label>
            <Input
              className="extra"
              inputField={inputFields.city}
              onChange={handleChange}
              onClickDropdownItem={handleSelectDropDown}
            />
          </div>
          <div className="address">
            <label>Full Address</label>
            <Input
              className="extra"
              inputField={inputFields.address}
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="row">
          <div className="city">
            <label>Currency</label>
            <Input
              className="extra"
              inputField={inputFields.currency}
              onChange={handleChange}
              onClickDropdownItem={handleSelectDropDown}
            />
          </div>
        </div>
        <div className="button">
          <button className="cancel">Cancel</button>
          <button className="submit">Save Office</button>
        </div>
      </div> */}
    </WithSidebar>
  );
};
export default Profile;
